export default function initShareButton(target) {
  target.querySelectorAll("[data-share-fab]").forEach(function (fab) {
    function closeDropdown() {
      fab.querySelector(".hs-dropdown-toggle").click();
    }

    var shareUrl = encodeURIComponent(window.location.href);

    var fbLink = fab.querySelector("[data-share-fb]");
    if (fbLink) {
      fbLink.href =
        "https://www.facebook.com/sharer/sharer.php?u=" + shareUrl;
      fbLink.addEventListener("click", function () {
        closeDropdown();
      });
    }

    var linkedinLink = fab.querySelector("[data-share-linkedin]");
    if (linkedinLink) {
      linkedinLink.href =
        "https://www.linkedin.com/sharing/share-offsite/?url=" + shareUrl;
      linkedinLink.addEventListener("click", function () {
        closeDropdown();
      });
    }

    var copyBtn = fab.querySelector("[data-copy-link]");
    if (!copyBtn) return;
    var copyIcon = copyBtn.querySelector("[data-copy-icon]");
    var checkIcon = copyBtn.querySelector("[data-check-icon]");
    copyBtn.addEventListener("click", function () {
      navigator.clipboard.writeText(window.location.href);
      copyIcon.classList.add("hidden");
      checkIcon.classList.remove("hidden");
      setTimeout(function () {
        checkIcon.classList.add("hidden");
        copyIcon.classList.remove("hidden");
        closeDropdown();
      }, 500);
    });
  });
}
